import {
    getPaymentIntent,
    listPaymentIntents
} from './queries';
import {
    createPaymentIntent,
    deletePaymentIntent,
    updatePaymentIntent,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreatePaymentIntent,
    DeletePaymentIntent,
    GetPaymentIntent,
    ListPaymentIntents,
    PaymentIntent,
    UpdatePaymentIntent
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListPaymentIntents>>({
                                                                                query: listPaymentIntents,
                                                                                variables: {filter: filter, limit, nextToken},
                                                                            });
    return response.data?.listPaymentIntents;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetPaymentIntent>>({
                                                                              query: getPaymentIntent,
                                                                              variables: {id: id},
                                                                          });
    return response.data?.getPaymentIntent;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreatePaymentIntent>>({
                                                                                 query: createPaymentIntent,
                                                                                 variables: {input: payload},
                                                                             });

    return response.data?.createPaymentIntent;
};

export const update = async (_id: string, record: PaymentIntent) => {

    const payload = {...record} as Record<string, unknown>;
    delete payload.created;

    const response = await client.graphql<GraphQLQuery<UpdatePaymentIntent>>({
                                                                                 query: (updatePaymentIntent),
                                                                                 variables: {input: payload},
                                                                             });
    return response.data?.updatePaymentIntent;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeletePaymentIntent>>({
                                                                                 query: (deletePaymentIntent),
                                                                                 variables: {input: {id: id}},

                                                                             });
    return response.data?.deletePaymentIntent;
};
